import React from "react";
import {cx} from "../../lib/ClassSet";
import ContextMenuTrigger from "../../components/ContextMenuTrigger";

const SubscriptionProductItem = (props) => {

  let {data} = props;

  let classes = cx({
    "item": true,
    "accounts-customer-subscription-product-item": true,
    "u-selected": props.selected
  })

  let contextClickFn = (x, y) => props.onContextMenuClick(data.get("productSku"), x, y);

  return (
    <li className={classes} onClick={(e) => props.onClick(data, e)}>
      <div className="field f-title"><span className="title">{data.get("productTitle")}</span> <span className="sku">{data.get("productSku")}</span></div>
      <div className="field f-quantity">{data.get("quantity")} x {data.get("unitPrice")} {data.get("currency")}</div>
      <div className="field f-context"><ContextMenuTrigger active={true} onClick={contextClickFn}/></div>
    </li>
  )
}

export default SubscriptionProductItem;